import React, { useEffect, useState } from "react";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useNavigate } from "react-router-dom";

import Topbar from "../../../Component/Topbar/Topbar";
import { Table } from "../../../Component/Table/Table";
import { edit, search, view } from "../../../assets/img";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import DateRange from "../../../Component/DateRange/DateRange";
import SelectBox from "../../../Component/SelectBox";
import { URLS } from "../../redux/api/Constants";
import { get, post } from "../../redux/api/ApiHandler";
import moment from "moment";
import useSearchFunction from "../../../Component/searchFunction";
import SelectBox1 from "../../../Component/SelectBox1";

const InventoryTable = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [selected, setSelected] = useState(null);
  const [status, setStatus] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [regionOptions, setRegionOptions] = useState([]);
  const [fromDates, setFromDates] = useState(null);
  const [toDates, setToDates] = useState(null);
  const [count, setCount] = useState(0);

  const debounceval = useSearchFunction(searchValue);

  const statusMap = {
    yet_to_start: { label: "Yet to Start", className: "yet_to_start_btn" },
    dispatched: { label: "Dispatched", className: "dispatched_btn" },
    delivered: { label: "Delivered", className: "delivered_btn" },
  };

  const statusOptions = [
    { value: 4, label: "Yet to Start" },
    { value: 9, label: "Dispatched" },
    { value: 10, label: "Delivered" },
  ];

  const ticketList = async (search, status, selected, fromDate, toDate) => {
    setSearchValue(search);
    setFromDates(fromDate);
    setToDates(toDate);
    setSelected(selected);
    setStatus(status);

    let payload = {
      search: search,
      // page: page,
      region_id: selected?.value,
      type: 2,
      current_status: status?.value,
      from_date: fromDate ? moment(fromDate).format("DD-MM-YYYY") : "",
      to_date: toDate ? moment(toDate).format("DD-MM-YYYY") : "",
    };
    let res = await post(URLS.TICKET_LIST, payload);
    if (res?.status === "success") {
      let array = [4, 9, 10];
      let arr = res?.lists.filter((item) =>
        array.includes(item?.current_status),
      );
      setCount(arr.length);
      let mappedData = arr.map((item) => {
        let obj = { ...item };
        obj.trackin_id = item?.ticket_details
          ?.reverse()
          ?.find((i) => i.tracking)?.tracking?.tracking_no;
        return obj;
      });

      // let mappedData = res?.lists
      //   .map(item => {
      //     let obj = { ...item };
      //     // 1. Latest tracking
      //     obj.trackin_id = [...item?.ticket_details]
      //       .reverse()
      //       .find(i => i.tracking)?.tracking?.tracking_no || "";
      //     // 2. For current_status == 8 → check latest assigned_for == 3
      //     if (item?.current_status === 8) {
      //       const latestDetail = [...item.ticket_details]
      //         .reverse()
      //         .find(i => i?.assigned_for === 3);
      //       if (latestDetail) {
      //         obj.latest_assigned_details = latestDetail;
      //         obj.include_by_status8 = true; // mark this item for the filter
      //       }
      //     }

      //     return obj;
      //   })
      //   .filter(item =>
      //     array.includes(item.current_status) || item.include_by_status8
      //   );

      // console.log(mappedData, "mappedData");
      setList(mappedData);
      setPagination(res?.pagination_meta);
    }
  };

  const regionList = async () => {
    let res = await get(URLS.REGIONLIST);
    if (res?.status === "success" && Array.isArray(res?.roles)) {
      // 🔹 Convert API data to Select options
      const options = res?.roles.map((region) => ({
        value: region?.id,
        label: region?.name,
      }));
      setRegionOptions(options);
    }
  };

  useEffect(() => {
    ticketList(debounceval);
    regionList();
  }, [debounceval, page]);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Regional Ticket ID",
        accessor: "code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Region",
        accessor: "region",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Regional Manager",
        accessor: "regional_manager",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Service Engineer",
        accessor: "service_engineer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Customer ID",
        accessor: "customer.code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Customer Name",
        accessor: "customer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name}</p>;
        },
      },

      {
        Header: "Created By",
        accessor: "created_by",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name}</p>;
        },
      },

      {
        Header: "Date",
        accessor: "opened_at",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Tracking ID",
        accessor: "trackin_id",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap " style={{ color: "#1A77BC" }}>
              {/* {value?.tracking?.tracking_no ? value?.tracking?.tracking_no : "-"} */}
              {value ? value : "-"}
            </p>
          );
        },
      },

      {
        Header: "Status",
        accessor: "current_status",
        Cell: ({ value, row }) => {
          // const { label, className } = statusMap[value] || {
          //   label: "Unknown",
          //   className: "default_btn",
          // };
          return (
            <div className="d-flex ac-js">
              <button
                className={`${
                  value == 4 || value == 8
                    ? "yet_to_start_btn"
                    : value == 9
                      ? "dispatched_btn"
                      : value == 10
                        ? "delivered_btn"
                        : "dispatched_btn"
                } f1 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16`}
              >
                {value == 4 || value == 8
                  ? "Yet to start"
                  : value == 9
                    ? "Dispatched"
                    : value == 10
                      ? "Delivered"
                      : "-"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: ({ value, row }) => {
          const status = row.original.status; // Access current row's status
          return (
            <div className="d-flex ac-jc mt-2 gap-3">
              {/* View button — always visible */}
              <button
                onClick={() => {
                  navigate("/inventory-view", {
                    state: {
                      type: "view",
                      id: row?.original?.id,
                      status: row?.original?.current_status,
                    },
                  });
                }}
                className="cust-btn "
              >
                <img src={view} alt="" className="editor-btn" />
              </button>

              {/* Edit button — only show if not delivered */}
              {/* {status !== 10 && (
                <button
                  onClick={() => {
                    navigate("/inventory-view", { state: { type: "edit", id: row?.original?.id } });
                  }}
                  className="cust-btn "
                >
                  <img src={edit} alt="" className="editor-btn" />
                </button>
              )} */}
            </div>
          );
        },
      },
    ],
    [],
  );
  return (
    <>
      <Topbar header={"Inventory"} />
      <div className="container_fluit1">
        <div className="d-flex ac-jb">
          <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
            Total Count : {count}
          </h4>
        </div>
        <div className="d-flex ac-je gap-3 my-4">
          <DateRange
            fromDate={fromDates}
            setFromDate={(val) =>
              ticketList(searchValue, status, selected, val, toDates)
            }
            toDate={toDates}
            setToDate={(val) =>
              ticketList(searchValue, status, selected, fromDates, val)
            }
          />
          <div className="col-md-2">
            <SelectBox1
              placeholder={"Status"}
              selected={status}
              setSelected={(val) =>
                ticketList(searchValue, val, selected, fromDates, toDates)
              }
              options={statusOptions}
            />
          </div>
          <div className="col-md-2">
            <SelectBox
              options={regionOptions}
              selected={selected}
              setSelected={(val) =>
                ticketList(searchValue, status, val, fromDates, toDates)
              }
            />
          </div>

          <div className="search-input col-md-3 d-flex ac-jb ">
            <input
              value={searchValue}
              onChange={(e) =>
                setSearchValue(
                  e.target.value,
                  status,
                  selected,
                  fromDates,
                  toDates,
                )
              }
              type="text"
              placeholder="Search "
              className="search-field f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-18 fs-xxl-20"
            />
            <img src={search} className="search" />
          </div>
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          // pagecount={pagination}
          pageno={page}
          data={list ?? []}
          show={true}
        />
      </div>
    </>
  );
};

export default InventoryTable;
